import styled from 'styled-components';
import { buttonPrimaryStyles, buttonPrimaryHoverStyles, buttonPrimaryActiveStyles, buttonPrimaryDisabledStyles } from '@nicollet/common';
export { buttonPrimaryActiveStyles, buttonPrimaryDisabledStyles, buttonPrimaryHoverStyles, buttonPrimaryStyles } from '@nicollet/common';
import { BaseButton } from '../BaseButton/index.js';

const ButtonPrimary = styled(BaseButton)`
  ${buttonPrimaryStyles}

  &:hover {
    ${buttonPrimaryHoverStyles}
  }

  &:active {
    ${buttonPrimaryActiveStyles}
  }

  &:disabled {
    ${buttonPrimaryDisabledStyles};

    &:hover {
      ${buttonPrimaryDisabledStyles};
    }
  }
`;

export { ButtonPrimary };
